import React from 'react'
import { variantMappers } from 'src/utils'
import Icon from 'src/components/Icon'
import iconData from 'src/assets/data/selection.json'

export default function getOSIcon(device) {
    const { COMPUTED_OS_MAP } = variantMappers
    const { icons } = iconData
    if (!device) {
        return null
    }
    const { computed_os } = device
    const deviceIcon = COMPUTED_OS_MAP[computed_os] || COMPUTED_OS_MAP.default
    const iconObj =
        icons.find(element => {
            return element.properties.name === deviceIcon
        }) ?? icons[0]
    return <Icon icon={iconObj} />
}
